<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    @if (cart) {
      <ion-title>
        @if (!cart.person) {
          <span>Add customer</span>
        }
        @if (cart.person) {
          <span>Change customer</span>
        }
      </ion-title>
    }
    @if (online) {
      <ion-buttons slot="end">
        @if (permissionService.isPermitted('pos-people-add-person')) {
          <ion-button (click)="presentAddPersonModal()">
            <fa-icon [icon]="['far', 'plus']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
          </ion-button>
        }
      </ion-buttons>
    }
  </ion-toolbar>

  <ion-toolbar>
    <ion-searchbar #query_search_bar_input placeholder="Search by name, email or phone" debounce="200" [(ngModel)]="query" (ionInput)="searchPeople()"></ion-searchbar>
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (visible_people) {
    <ion-list lines="none">
      @for (person of visible_people; track person) {
        <ion-item lines="full" button="true" detail="true" (click)="customerClicked(person)">
          <ion-label>
            <h3 class="ion-text-wrap">
              @if (person.full_name) {
                <span>{{person.full_name}} (#{{person.number}})</span>
              }
              @if (!person.full_name) {
                <span>#{{person.number}}</span>
              }
            </h3>
            <ion-grid class="ion-no-padding">
              @if (person.job_title) {
                <ion-row>
                  <ion-col>
                    <h5>Job title</h5>
                    <p class="prominent">{{person.job_title}}</p>
                  </ion-col>
                </ion-row>
              }
              @if (person.organisation) {
                <ion-row>
                  <ion-col>
                    <h5>Organisation</h5>
                    <p class="prominent">{{person.organisation.title}}</p>
                  </ion-col>
                </ion-row>
              }
              @if (person.mobile_phone_number || person.home_phone_number || person.work_phone_number) {
                <ion-row>
                  @if (person.mobile_phone_number) {
                    <ion-col size="auto">
                      <h5>Mobile phone number</h5>
                      <p class="prominent">{{person.mobile_phone_number}}</p>
                    </ion-col>
                  }
                  @if (person.home_phone_number) {
                    <ion-col size="auto">
                      <h5>Home phone number</h5>
                      <p class="prominent">{{person.home_phone_number}}</p>
                    </ion-col>
                  }
                  @if (person.work_phone_number) {
                    <ion-col size="auto">
                      <h5>Work phone number</h5>
                      <p class="prominent">{{person.work_phone_number}}</p>
                    </ion-col>
                  }
                </ion-row>
              }
              @if (person.email_address) {
                <ion-row>
                  <ion-col size="12">
                    <h5>Email address</h5>
                    <p class="prominent">{{person.email_address}}</p>
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }

  @if (visible_people && visible_people.length != 0) {
    <ion-infinite-scroll threshold="100px" (ionInfinite)="showMoreVisiblePeople($event)">
      <ion-infinite-scroll-content loadingSpinner="crescent" loadingText="Loading"></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  }

  @if (visible_people && visible_people.length == 0) {
    <ion-grid class="nothing-found">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <p>
            <fa-icon [icon]="['fal', 'user']" size="6x"></fa-icon>
            <span>No people found</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>